import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { useDeadlineExpiredWithNoReverseStyles } from './styles';
import {
  messageFormNoteReverse,
  messageFormNotDoneReverse,
  messageFormNotDoneReverseRipleyCard,
} from '../../../../constants/texts';
import AppSelectCustom from '../../../../components/common/AppSelectCustom';
import { optionMapper } from '../../../../helpers/tickets/PaymentTypeHelper';
import AppInput from '../../../common/AppInput';
import bearContacUsIcon from '../../../../assets/bearContactUs.svg';
import { useSelector } from 'react-redux';

const Form = ({ ...props }) => {
  const { state, onData, mobile, setShowForm } = props;

  const { status } = useSelector((state) => state.validationProductSlice);

  const [paymentMethod, setPaymentMethod] = useState(true);

  const classes = useDeadlineExpiredWithNoReverseStyles({ mobile });

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
  };

  const handlePaymentMethod = (e) => {
    setPaymentMethod(e.target.value);
    onData({ name: e.target.name, value: e.target.value });
  };

  useEffect(() => {
    setShowForm(status);
  }, [status]);

  useEffect(() => {
    if (paymentMethod === 'Tarjeta Ripley' || paymentMethod === 'Chek') {
      setShowForm(false);
    } else if (
      paymentMethod === 'Tarjeta de débito' ||
      paymentMethod === 'Tarjeta de crédito'
    ) {
      setShowForm(true);
    }
  }, [paymentMethod]);

  return (
    <React.Fragment>
      <Typography className={classes.titleMessageNotReverse}>
        {messageFormNoteReverse}
      </Typography>
      <Typography className={classes.titleMessageNotDoneReverse}>
        {messageFormNotDoneReverse}
      </Typography>
      <Typography className={classes.titlePayMethodUsed}>
        Selecciona el medio de pago que utilizaste
      </Typography>
      <AppSelectCustom
        label={state['paymentMethod']?.label}
        name={'paymentMethod'}
        value={state['paymentMethod']?.value || ''}
        options={optionMapper.get('paymentMethod')}
        onChange={handlePaymentMethod}
        onClick={() => {}}
        onBlur={() => {}}
        notPaddingContainer={true}
      />
      {(paymentMethod === 'Tarjeta de débito' ||
        paymentMethod === 'Tarjeta de crédito') && (
        <React.Fragment>
          <Typography className={classes.titlePayMethodUsed}>
            Selecciona tu banco
          </Typography>
          <AppSelectCustom
            label={state['bank']?.label}
            name={'bank'}
            value={state['bank']?.value || ''}
            options={optionMapper.get('bank')}
            onChange={handleChange}
            onClick={() => {}}
            onBlur={() => {}}
            notPaddingContainer={true}
          />
          <Typography className={classes.titlePayMethodUsed}>
            Déjanos tu comentario
          </Typography>
          <AppInput
            onChange={handleChange}
            onBlur={() => {}}
            onClick={() => {}}
            disabled={false}
            name={'comment'}
            error={false}
            type={state['comment']?.type || ''}
            label={'Escribir comentario'}
            required={true}
            inputAdornment={''}
            success={state['comment']?.success || ''}
            helperText={''}
            multiline={true}
            rows={4}
            value={state['comment']?.value || ''}
            errorMessage={''}
          />
        </React.Fragment>
      )}
      {(paymentMethod === 'Tarjeta Ripley' || paymentMethod === 'Chek') && (
        <React.Fragment>
          <Typography className={classes.messageInfoMethodRipleyOrCheck}>
            {messageFormNotDoneReverseRipleyCard}
          </Typography>
          <Typography className={classes.imageContainer}>
            <img className={classes.image} src={bearContacUsIcon} alt="" />
          </Typography>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  fields: PropTypes.array,
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  setShowForm: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
};

export default Form;
